import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Settings, Wrench, Network, Cloud, Shield, Briefcase } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from './ui/card';
import { Button } from './ui/button';

const iconMap = {
  settings: Settings,
  wrench: Wrench,
  network: Network,
  cloud: Cloud,
  shield: Shield,
  briefcase: Briefcase
};

const gradientMap = {
  settings: { bg: 'from-blue-500 to-cyan-500', card: 'from-blue-50 to-cyan-50', border: 'hover:border-blue-300' },
  wrench: { bg: 'from-orange-500 to-pink-500', card: 'from-orange-50 to-pink-50', border: 'hover:border-orange-300' },
  network: { bg: 'from-purple-500 to-indigo-500', card: 'from-purple-50 to-indigo-50', border: 'hover:border-purple-300' },
  cloud: { bg: 'from-cyan-500 to-blue-500', card: 'from-cyan-50 to-blue-50', border: 'hover:border-cyan-300' },
  shield: { bg: 'from-green-500 to-emerald-500', card: 'from-green-50 to-emerald-50', border: 'hover:border-green-300' },
  briefcase: { bg: 'from-indigo-500 to-purple-500', card: 'from-indigo-50 to-purple-50', border: 'hover:border-indigo-300' }
};

export const ServiceCard = ({ service }) => {
  const Icon = iconMap[service.icon] || Settings;
  const gradient = gradientMap[service.icon] || gradientMap.settings;

  return (
    <Card className={`h-full hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent ${gradient.border} bg-gradient-to-br ${gradient.card} group overflow-hidden relative`}>
      {/* Effet de brillance au hover */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
      
      <CardHeader className="relative z-10">
        <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${gradient.bg} flex items-center justify-center mb-4 shadow-lg transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`}>
          <Icon className="w-8 h-8 text-white" />
        </div>
        <CardTitle className="text-xl text-gray-900 group-hover:text-gray-800 transition-colors">
          {service.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="relative z-10">
        <CardDescription className="text-gray-600 leading-relaxed text-base">
          {service.shortDescription}
        </CardDescription>
      </CardContent>
      <CardFooter className="relative z-10">
        <Button
          asChild
          variant="ghost"
          className={`w-full justify-between text-gray-700 hover:text-gray-900 hover:bg-white/50 group-hover:bg-white/70 transition-all font-semibold`}
        >
          <Link to={`/services/${service.slug}`}>
            En savoir plus
            <ArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" />
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};
